import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import { stylesFor, zIndexFor, darken } from '../styles/utilities';

const NavHeight = '80px';

// Reserve space for the Nav to float above.
const Root = styled.div`
  height: ${NavHeight};
`;

// Floating container for the Nav.
const Float = styled.nav`
  background-color: ${props => props.theme.color.white};
  height: NavHeight;
  left: 0px;
  overflow: hidden;
  position: fixed;
  right: 0px;
  top: 0px;
  transition: height 0.2s ease-in;
  z-index: ${zIndexFor('Nav')};

  ${stylesFor.underXLarge`
    height: ${props => (props.isOpen ? '100%' : NavHeight)};
  `};
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  height: ${NavHeight};
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1600px;
  padding: 0 20px;
  width: 100%;

  ${stylesFor.mediumUp`
    padding: 0 60px;
  `};
`;

const Logo = styled.span`
  color: ${props => props.theme.color.sharePointTeal};
  font-size: 24px;
  font-weight: ${props => props.theme.font.weight.semibold};
`;

const MobileNavButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  outline: none;
  padding: 0;

  ${stylesFor.xLargeUp`
    display: none;
  `};
`;

const Items = styled.ul`
  align-items: center;
  display: flex;

  list-style-type: none;
  margin: 0;
  padding: 0;

  ${stylesFor.underXLarge`
    flex-direction: column;
    left: 0;
    opacity: ${props => (props.isOpen ? '1' : '0')}
    position: absolute;
    right: 0;
    top: ${NavHeight};
    transition: opacity 0.2s ease;
    z-index: ${zIndexFor('Nav')};
  `};
`;

const Item = styled.li`
  color: ${props => props.theme.color.sharePointTeal};
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  font-weight: ${props => props.theme.font.weight.bold};
  letter-spacing: 1px;
  text-transform: uppercase;

  ${stylesFor.underXLarge`
    align-items: center;
    display: flex;
    height: 60px;
    justify-content: center;
    width: 100%;

    &:hover {
      background-color: #f9f9f9;
    }
  `};

  ${stylesFor.xLargeUp`
    &:not(:last-of-type) {
      margin-right: 24px;
    }
  `};
`;

const LinkWrapper = styled.div`
  padding: 4px 8px;

  &:hover {
    color: ${props => darken(props.theme.color.sharePointTeal)};
  }

  img {
    display: none;
  }

  ${props =>
    props.isExternal
      ? css`
          background-color: ${props => props.theme.color.teal};
          color: ${props => props.theme.color.white};

          &:hover {
            background-color: ${props => darken(props.theme.color.teal)};
            color: ${props => props.theme.color.white};
          }

          img {
            display: inline;
            height: 10px;
            margin-left: 4px;
            width: 18px;
          }
        `
      : ''};
`;

export default class nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  // Prevent scrolling of the page when the menu is open.
  componentDidUpdate() {
    // Overflow is enough to prevent scroll on desktop and Android systems.
    document.body.style.overflow = this.state.isOpen ? 'hidden' : 'visible';

    // For iOS we need to block touchmove events.
    document.body.ontouchmove = e => {
      if (this.state.isOpen) {
        e.preventDefault;
        return false;
      }
    };
  }

  render() {
    const { links } = this.props;
    const { isOpen } = this.state;

    return (
      <Root>
        <Float isOpen={isOpen}>
          <Content>
            <Logo>SharePoint</Logo>
            <Items isOpen={isOpen}>
              {links.map(link => (
                <Item
                  key={link.text}
                  onClick={() => this.handleClick(link.section, link.url)}
                  isExternal={link.isExternal}
                >
                  <LinkWrapper isExternal={link.isExternal}>
                    {link.text}
                    <img src="images/iconExternal.svg" />
                  </LinkWrapper>
                </Item>
              ))}
            </Items>
            <MobileNavButton onClick={this.toggleMenu}>
              <img src="images/iconHamburger.svg" />
            </MobileNavButton>
          </Content>
        </Float>
      </Root>
    );
  }

  toggleMenu = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleClick = (section, url) => {
    const { onClick } = this.props;

    // Close the menu.
    this.setState({
      isOpen: false,
    });

    // Notify the callback function.
    onClick(section, url);
  };
}



// WEBPACK FOOTER //
// ./src/components/nav.js